const STORAGE_KEY = "default_location";

export function persistDefaultLocation(location) {
  if (!location?.value) {
    clearDefaultLocationStorage();
    return;
  }

  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      value: location.value,
      label: location.label ?? String(location.value),
    }),
  );
}

export function readDefaultLocationFromStorage() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    if (parsed?.value == null || parsed.value === "") {
      return null;
    }
    return {
      value: parsed.value,
      label: parsed.label ?? String(parsed.value),
    };
  } catch {
    return null;
  }
}

export function clearDefaultLocationStorage() {
  localStorage.removeItem(STORAGE_KEY);
}
